import { useRef, useEffect, useCallback } from 'react';
import { useDocsStore } from '../../stores/docsStore';

export function FileEditor() {
  const { editBuffer, updateEditBuffer, saveFile, saving } = useDocsStore();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Handle Cmd/Ctrl+S to save
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 's') {
      e.preventDefault();
      saveFile();
    }

    // Tab inserts spaces instead of changing focus
    if (e.key === 'Tab') {
      e.preventDefault();
      const textarea = e.currentTarget;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const value = textarea.value;
      const newValue = value.substring(0, start) + '  ' + value.substring(end);
      updateEditBuffer(newValue);
      // Restore cursor position after React re-render
      requestAnimationFrame(() => {
        textarea.selectionStart = textarea.selectionEnd = start + 2;
      });
    }
  }, [saveFile, updateEditBuffer]);

  // Focus textarea on mount
  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  const lineCount = editBuffer.split('\n').length;
  const charCount = editBuffer.length;

  return (
    <div className="flex flex-col h-full">
      <textarea
        ref={textareaRef}
        value={editBuffer}
        onChange={(e) => updateEditBuffer(e.target.value)}
        onKeyDown={handleKeyDown}
        className="flex-1 w-full bg-bg-primary text-text-primary text-sm font-mono p-4 resize-none outline-none border-none leading-relaxed"
        spellCheck={false}
        disabled={saving}
      />
      <div className="flex-shrink-0 flex items-center justify-between px-4 py-1.5 bg-bg-tertiary border-t border-border-subtle text-[10px] text-text-muted">
        <span>{lineCount} lines, {charCount.toLocaleString()} chars</span>
        <span>Cmd+S to save &middot; Tab for indent</span>
      </div>
    </div>
  );
}

export default FileEditor;
